import noop from "lodash/noop";
import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

export type RightPanelKey = "settings";

const RightPanelContext = createContext<{
  activePanel?: RightPanelKey;
  toggle: (panel: RightPanelKey) => void;
  close: () => void;
}>({
  toggle: noop,
  close: noop,
});

export function RightPanelProvider({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const [activePanel, setActivePanel] = useState<RightPanelKey | undefined>(
    undefined
  );

  const toggle = useCallback(
    (panel: RightPanelKey) =>
      setActivePanel((prev) => (prev === panel ? undefined : panel)),
    []
  );
  const close = useCallback(() => setActivePanel(() => undefined), []);

  const value = useMemo(
    () => ({
      activePanel,
      toggle,
      close,
    }),
    [activePanel, toggle, close]
  );

  return (
    <RightPanelContext.Provider value={value}>
      {children}
    </RightPanelContext.Provider>
  );
}

export function useRightPanel() {
  return useContext(RightPanelContext);
}
